'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _initGpt = require('./initGpt');

var _initGpt2 = _interopRequireDefault(_initGpt);

var _initLotameTargeting = require('./initLotameTargeting');

var _initLotameTargeting2 = _interopRequireDefault(_initLotameTargeting);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _stringHash = require('string-hash');

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setTargeting = function setTargeting(slot, targetingData, lotameTargeting) {
  slot.clearTargeting();

  if (lotameTargeting && window.lotameGPTData) {
    slot.setTargeting('ccaud', [window.lotameGPTData]);
  }

  targetingData.map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;

    slot.setTargeting(key, value);
  });
};

var GooglePublisherTag = function (_Component) {
  _inherits(GooglePublisherTag, _Component);

  function GooglePublisherTag(props) {
    _classCallCheck(this, GooglePublisherTag);

    var _this = _possibleConstructorReturn(this, (GooglePublisherTag.__proto__ || Object.getPrototypeOf(GooglePublisherTag)).call(this));

    _this.tagName = (0, _stringHash2.default)(props.tagId).toString();
    _this.debounceRefreshAd = (0, _lodash2.default)(_this.refreshAd, props.debounceTimer);
    return _this;
  }

  _createClass(GooglePublisherTag, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.gt = (0, _initGpt2.default)();

      if (this.props.lotameTargeting) {
        (0, _initLotameTargeting2.default)();
      }

      this.refreshAd(this.gt, this.tagName, this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currTargeting = JSON.stringify(this.props.targetingData);
      var newTargeting = JSON.stringify(nextProps.targetingData);

      if (currTargeting !== newTargeting) {
        this.debounceRefreshAd(this.gt, this.tagName, nextProps);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'refreshAd',
    value: function refreshAd(gt, tagName, _ref2) {
      var tagId = _ref2.tagId,
          width = _ref2.width,
          height = _ref2.height,
          targetingData = _ref2.targetingData,
          lotameTargeting = _ref2.lotameTargeting;

      gt.cmd.push(function () {
        if (!gt.slots[tagName]) {
          gt.slots[tagName] = gt.defineSlot(tagId, [width, height], tagName).addService(gt.pubads());
          gt.display(tagName);
        }

        setTargeting(gt.slots[tagName], targetingData, lotameTargeting);

        gt.pubads().refresh([gt.slots[tagName]]);
      });

      this.props.logger();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { id: this.tagName });
    }
  }]);

  return GooglePublisherTag;
}(_react.Component);

GooglePublisherTag.propTypes = {
  tagId: _react.PropTypes.string.isRequired,
  width: _react.PropTypes.number.isRequired,
  height: _react.PropTypes.number.isRequired,
  debounceTimer: _react.PropTypes.number,
  targetingData: _react.PropTypes.array,
  lotameTargeting: _react.PropTypes.bool,
  logger: _react.PropTypes.func
};
GooglePublisherTag.defaultProps = {
  debounceTimer: 1500,
  targetingData: [],
  lotameTargeting: false,
  logger: function logger() {}
};
exports.default = GooglePublisherTag;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/build/GooglePublisherTag/GooglePublisherTag.js
 ** module id = 839
 ** module chunks = 0
 **/